import React, { useState, useEffect } from "react";
import Sidebar from "../Common/Sidebar";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Loader from "../Common/Loader";
import { TabView, TabPanel } from "primereact/tabview";
import { Card } from "primereact/card";
import { InputText } from "primereact/inputtext";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Tag } from "primereact/tag";
import { Calendar } from "primereact/calendar";
import { Button } from "react-bootstrap";

type Webinar = {
  id: number;
  userId: number | null;
  userName: string | null;
  title: string | null;
  start_time: string |null;
  duration_minutes: string | null;
  host_email: string | null;
  participants: string | null;
  transcript: string | null;
  chat_log: string | null;
  dial_in_locations: string | null;
  recording_url: string | null;
};

export default function WebinarLandingPage() {
  const [webinarData, setWebinarData] = useState<Webinar[] | null>(null);
  const [showWideSidebar, setShowWideSidebar] = useState(true);
  const [loading, setLoading] = useState(false);
  const [activeTab, setActiveTab] = useState(0);
  const [filterText, setFilterText] = useState("");
  const [globalFilter, setGlobalFilter] = useState("");
  const [dateFrom, setDateFrom] = useState<Date | null>(null);
  const [dateTo, setDateTo] = useState<Date | null>(null);
  const [titleFilter, setTitleFilter] = useState("");
  const [hostFilter, setHostFilter] = useState("");
  const [locationFilter, setLocationFilter] = useState("");

  const navigate = useNavigate();

 useEffect(() => {
  const fetchWebinar = async () => {
    setLoading(true);
    try {
      const token = localStorage.getItem("igtoken");
      const response = await axios.get<{ data: Webinar[] }>(
        `${process.env.REACT_APP_Alexandria_API}/api/Alexandria/webinar/get`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setWebinarData(response.data.data);
    } catch (error) {
      console.error("Error fetching webinar:", error);
    }
    setLoading(false);
   };
   fetchWebinar();
  }, []);

  useEffect(() => {
      const currentDate = new Date();
      const datefrom = new Date();
      datefrom.setDate(currentDate.getDate() - 15);
      setDateFrom(datefrom);
      setDateTo(currentDate);
    }, []);
const filteredWebinars = webinarData?.filter((webinar) => {
  const title = webinar.title ?? '';
  const hostEmail = webinar.host_email ?? '';
  const location = webinar.dial_in_locations ?? '';
  const startTime = new Date(webinar.start_time??'');
  const titleMatch = titleFilter
    ? title.toLowerCase().includes(titleFilter.toLowerCase())
    : true;
  const hostMatch = hostFilter
    ? hostEmail.toLowerCase().includes(hostFilter.toLowerCase())
    : true;
  const locationMatch = locationFilter
    ? location.toLowerCase().includes(locationFilter.toLowerCase())
    : true;
  const dateFromMatch = dateFrom ? startTime >= dateFrom : true;
  const dateToMatch = dateTo ? startTime <= dateTo : true;
  return titleMatch && hostMatch && locationMatch && dateFromMatch && dateToMatch;
}) || [];

const clearFilters = () => {
     const currentDate = new Date();
     const datefrom = new Date();
     datefrom.setDate(currentDate.getDate() - 15);
    setHostFilter("");
    setTitleFilter("");
    setLocationFilter("");
    setDateFrom(datefrom);
    setDateTo(currentDate);
  };
  const onSummaryClick = (data: any) => {
    navigate("/webinaranalysis", { state: { data } });
  };

  const onSidebarValueChanged = (value: boolean) => {
  setShowWideSidebar(value);
  };

  return (
    <div className="d-flex vh-100 bg-light">
      <Sidebar pagename="webinar" onSidebarValueChanged={onSidebarValueChanged}/>
      <div className="flex-grow-1 d-flex flex-column bg-light p-2 mt-4">
        <div className={`${
            showWideSidebar
              ? "main-content-large-width"
              : "main-content-small-width"
          }`}
        >
         <h2 className="fw-bold mb-3">Webinar</h2>
          <div className="card p-3">
               <div className="d-flex mt-4 mb-4 gap-4 dashboard-container">
                 <div className="info-block dashboard-card shadow-hover p-4 rounded-4 w-100 d-flex align-items-center justify-content-between">
                   <div>
                      <h2 className="dashboard-number mb-1">
                       {webinarData ? webinarData.length : 0}
                      </h2>
                      <p className="dashboard-label mb-0">
                      <i className="fas fa-video me-2"></i> Webinars
                    </p>
                  </div>
                </div>
               </div>
                 <p className="text-purple header-text mb-1">Filter By:</p>
                 <div className="row p-1 d-flex align-items-end" >
               <div className="col-md mb-1">
                 <label htmlFor="dateFrom" style={{ fontSize: "12px", color: "#381574" }}>Date From</label>
                   <Calendar
                      id="dateFrom"
                      placeholder="dd-mm-yyyy"
                      value={dateFrom}
                      onChange={(e) => setDateFrom(e.value ?? null)}
                      readOnlyInput 
                      maxDate={new Date()}
                      inputStyle={{fontSize: "12px", color: "#333",height: "30px",padding: "4px 8px",width: "100%",border: "1px solid #6e3bb7"}}
                      panelStyle={{ fontSize: "12px" }}
                      className="w-100"/>
                </div>
                <div className="col-md mb-1">
                  <label htmlFor="dateTo" style={{ fontSize: "12px", color: "#381574" }}>Date To</label>
                   <Calendar
                      id="dateTo"
                      placeholder="dd-mm-yyyy"
                      value={dateTo}
                      onChange={(e) => setDateTo(e.value ?? null)}
                      readOnlyInput                    
                      maxDate={new Date()}
                      inputStyle={{ fontSize: "12px", color: "#333",height: "30px", padding: "4px 8px", width: "100%", border: "1px solid #6e3bb7" }}
                      panelStyle={{ fontSize: "12px" }}
                      className="w-100"/>
                </div>
                <div className="col-md mb-1">
                  <label htmlFor="title" style={{ fontSize: "12px", color: "#381574" }}>Title</label>
                    <InputText
                      id="title"
                      value={titleFilter}
                      onChange={(e) => setTitleFilter(e.target.value)}
                      placeholder="Filter by Title"
                      className="custom-inputbox"/>
                </div>
                <div className="col-md mb-1">
                  <label htmlFor="host" style={{ fontSize: "12px", color: "#381574" }}>Host Name</label>
                    <InputText
                       id="host"  placeholder="Filter by Host"
                       value={hostFilter}
                       onChange={(e) => setHostFilter(e.target.value)}
                       className="custom-inputbox"/>
                </div>
                <div className="col-md mb-1">
                   <label htmlFor="direction" style={{ fontSize: "12px", color: "#381574" }}>Location</label>
                   <InputText
                      id="location"  placeholder="Filter by Location"
                      value={locationFilter}
                      onChange={(e) => setLocationFilter(e.target.value)}
                      className="custom-inputbox" />
                </div>
                {/* <div className="col-md mb-1">
                   <label htmlFor="tag" style={{ fontSize: "12px", color: "#381574" }}>Tag</label>
                   <InputText id="tag"  placeholder="Filter by Tag"
                     className="custom-inputbox" />
               </div> */}
               <div className="col-md-auto mb-1 d-flex align-items-end">
                   <Button
                    size="sm"
                    className="fa fa-undo undo-btn"
                    onClick={clearFilters}
                    title="Clear filters"
                    />
              </div>
            
             {loading ? (
               <div className="d-flex justify-content-center align-items-center">
                <Loader />
               </div>
                 ) : filteredWebinars.length > 0 ? (
             <TabView className="mb-2 tabview-tab">
               <TabPanel header="Table View">
                    <DataTable
                      value={filteredWebinars}
                      paginator rows={5}
                      className="support-call-table custom-bordered-datatable text-14"
                      emptyMessage="No webinars found."
                      globalFilter={globalFilter}
                      onRowClick={(e) => navigate("/webinaranalysis", { state: { data: e.data } })}
                      rowClassName={(data) => 'clickable-row'} 
                    >
                      <Column header="Sr.No" body={(rowData, options) => options.rowIndex + 1} />
                      <Column field="title" header="Title" sortable />
                      <Column field="host_email" header="Host" />
                      <Column header="Date Time" body={(rowData) =>new Date(rowData.start_time).toLocaleString()} />
                      <Column field="duration_minutes"header="Duration" body={(rowData) => `${rowData.duration_minutes} minutes`} />
                      {/* <Column field="participants" header="Participants" /> */}
                      {/* <Column field="chat_log" header="Chat Log" /> */}
                      {/* <Column field="dial_in_locations" header="Locations" /> */}
                    </DataTable>
                </TabPanel>

               <TabPanel header={<span>Card View</span>}>
                 <div className="card-row">
                 {filteredWebinars.map((webinar: any, index: number) => {
                  const participants = webinar.participants || 0;
                  const participantsColor = participants < 50 ? "#f77" : participants > 150 ? "#a2f4b9e6" : "#f8ed12c0";
                   return (
                    <div key={index} className="card-col">
                     <div className="card-container" onClick={() => onSummaryClick(webinar)} style={{ cursor: 'pointer' }}>
                        <div className="small-muted-text">
                          Title
                        </div>
                        <div style={{ fontWeight: "bold", marginBottom: "8px" }}>
                           {webinar.title}
                        </div>
                        <div className="row align-items-center">
                          <div className="col-6">
                             <div className="small-muted-text">
                               Host Email
                             </div>
                           <div className="styled-badge">{webinar.host_email}</div>
                         </div>       
                       </div>
                      <div className="small-muted-text mt-2">
                        Date Time
                      </div>
                     <div style={{ marginBottom: "10px" }}>
                        {new Intl.DateTimeFormat("en-US", {
                         year: "2-digit",
                         month: "2-digit",
                         day: "2-digit",
                         hour: "2-digit",
                         minute: "2-digit",
                       }).format(new Date(webinar.start_time))}
                   </div>
                    <Button
                      style={{backgroundColor: "#3b0a69",fontSize: "12px",padding: "4px 8px",width: "100px",}}>
                      See Analysis
                 </Button>
                </div>
              </div>
              );
             })}
           </div>
         </TabPanel>
        </TabView>
        ) : ( 
          <div style={{ textAlign: 'center', color: 'gray', padding: '20px' }}>
            <p>No webinars available !!</p>
          </div>
        )}
     </div>
    </div>
   </div>
  </div>
 </div>
 );
}
